/**
 * Product Surface Contract — UX presentation only.
 *
 * Internal modules may keep IDs, slugs, enums, event names, feature keys.
 * Tenant-facing copy MUST go through these helpers (or Renata BUSINESS_LEXICON).
 *
 * Rule: INFRASTRUCTURE → BUSINESS CAPABILITY → SIMPLE EXPERIENCE
 * Never expose Flow Engine / presets / dirty / draft English to merchants.
 */

/** Bundle / Flow lifecycle as commercial Spanish labels. */
export const LIFECYCLE_STATUS_ES: Record<string, string> = {
  draft: "Borrador",
  published: "Publicado",
  paused: "Pausado",
  inactive: "Pausado",
  archived: "Archivado",
  active: "Activo",
  pending: "Pendiente",
  dirty: "Cambios sin publicar",
};

export function lifecycleStatusLabel(status: string | null | undefined): string {
  if (!status) return "—";
  const key = String(status).trim().toLowerCase();
  return LIFECYCLE_STATUS_ES[key] ?? status;
}

/** Infra terms that must never be primary merchant UX. */
export const INFRA_TERMS_BLOCKLIST = [
  "flow engine",
  "preset",
  "dirty",
  "draft",
  "published",
  "composable_flows",
] as const;

/**
 * Commercial label for a product surface id (nav / hubs).
 * Keep TS/API ids unchanged; only UI strings.
 */
export const PRODUCT_SURFACE_LABELS = {
  bundles: "Packs",
  experience: "Experiencia",
  team: "Equipo",
  branches: "Sucursales",
  hardware: "Hardware",
  renata: "Renata",
  settings: "Configuración",
  developer: "API / Desarrollador",
  /** Not a merchant product — Flow Engine is infrastructure. */
  flowsEngine: "Motor de flujos",
} as const;

export function isMerchantProductPath(pathname: string): boolean {
  const p = pathname.replace(/\/+$/, "") || "/";
  // /app/flows is infrastructure inventory — not a merchant product surface
  if (p === "/app/flows" || p.startsWith("/app/flows/")) return false;
  return p.startsWith("/app/");
}
